import type { RouteObject } from 'react-router-dom';
import UserLayout from '../layouts/UserLayout';
import Home from '../pages/user/Home';
import Products from '../pages/user/Products';
import Cart from '../pages/user/Cart';
import Orders from '../pages/user/Orders';
import Profile from '../pages/user/Profile';
import AboutUs from '../pages/user/AboutUs';
import Contact from '../pages/user/Contact';
import NotFound from '../components/common/NotFound';
import ProductDetail from "../pages/user/ProductDetail";
import KITongHop from '../pages/user/KITongHop';
import CSBaoMat from '../pages/user/CSBaoMat';
import CSBaoHanhDoiTra from '../pages/user/CSBaoHanhDoiTra';
import CSThanhToan from '../pages/user/CSThanhToan';
import CSGiaoHang from '../pages/user/CSGiaoHang';
import DieuKhoanDieuKien from '../pages/user/DieuKhoanDieuKien';
import ChinhSach from '../pages/user/ChinhSach';
import CTGTongHop from '../pages/user/CTGTongHop';
import TinTuc from '../pages/user/TinTuc';
import TinTucTongHop from '../pages/user/TinTucTongHop';
import KiemTraSanPham from '../pages/user/KiemTraSanPham';

export const userRoutes: RouteObject = {
  // path: '/',  <--- XÓA DÒNG NÀY ĐI
  element: <UserLayout />,
  children: [
    { index: true, element: <Home /> },
    { path: 'home', element: <Home /> },
    { path: 'products', element: <Products /> },
    { path: 'cart', element: <Cart /> },
    { path: 'orders', element: <Orders /> },
    { path: 'profile', element: <Profile /> },
    { path: 'about-us', element: <AboutUs /> },
    { path: 'contact', element: <Contact /> },
    { path: 'thong-tin-ki', element: <KITongHop /> },
    { path: 'privacy-policy', element: <CSBaoMat /> },
    { path: 'warranty-return-policy', element: <CSBaoHanhDoiTra /> },
    { path: 'payment-policy', element: <CSThanhToan /> },
    { path: 'shipping-policy', element: <CSGiaoHang /> },
    { path: 'terms-conditions', element: <DieuKhoanDieuKien /> },
    { path: 'policy', element: <ChinhSach /> },
    { path: 'nhua-dieu-ctg', element: <CTGTongHop /> },
    { path: 'products/:productId', element: <ProductDetail /> },
    { path: 'news/:articleId', element: <TinTuc /> },
    { path: 'news', element: <TinTucTongHop /> },
    { path: 'kiem-tra-san-pham/:modelId/:serialNumber', element: <KiemTraSanPham /> },
    { path: 'kiem-tra-san-pham', element: <KiemTraSanPham /> },
    { path: '*', element: <NotFound /> },
  ],
};